"use client";

import { useEffect, useState } from "react";
import Image from "next/image";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  type CarouselApi,
} from "@/components/ui/carousel";

const partners = [
  { name: "Acc.Ventures", logo: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/logo-acc.png" },
  { name: "Ambient", logo: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/logo-ambient.png" },
  { name: "Chainlink", logo: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/logo-chainlink.png" },
  { name: "Cookie3", logo: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/logo-cookie3.png" },
  { name: "Fluent", logo: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/logo-fluent.png" },
  { name: "Folks", logo: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/logo-folks.png" },
  { name: "GMX", logo: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/logo-gmx.png" },
  { name: "Infinex", logo: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/logo-infinex.png" },
  { name: "Insomnia", logo: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/logo-insomnia.png" },
  { name: "MyStandard", logo: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/logo-mystandard.png" },
  { name: "P2P", logo: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/logo-p2p.png" },
  { name: "PAKA", logo: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/logo-paka.png" },
  { name: "Pi Squared", logo: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/logo-pisquared.png" },
  { name: "Reveel", logo: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/logo-reveel.png" },
  { name: "Solidus", logo: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/logo-solidus.png" },
  { name: "Teneo", logo: "https://pulsarmoney.b-cdn.net/quests/campaigns/swapper-portal/logo-teneo.png" },
];

export function BackedBySection() {
  const [api, setApi] = useState<CarouselApi>();

  useEffect(() => {
    if (!api) return;

    const autoplay = setInterval(() => {
      api.scrollNext();
    }, 2000);

    return () => clearInterval(autoplay);
  }, [api]);

  return (
    <section className="bg-swapper-primary py-12 md:py-16 lg:py-20">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            Partners
          </h2>
        </div>

        {/* Top divider with INVESTORS & BACKERS label */}
        <div className="relative mb-8 md:mb-12">
          <div className="h-px bg-white/30" />
          <div className="absolute left-0 top-1/2 -translate-y-1/2 bg-swapper-primary pr-6">
            <span className="text-white text-xs uppercase tracking-wider font-semibold">
              INVESTORS & BACKERS
            </span>
          </div>
        </div>

        {/* Scrolling Partners Container */}
        <div className="mb-8 py-8 max-w-[80vw] mx-auto">
          <Carousel
            opts={{
              loop: true,
              align: "start",
            }}
            setApi={setApi}
          >
            <CarouselContent className="-ml-8">
              {partners.map((partner, index) => (
                <CarouselItem
                  key={index}
                  className="basis-1/2 md:basis-1/3 lg:basis-1/5 pl-8"
                >
                  <div className="flex items-center justify-center h-16 px-4">
                    <Image
                      src={partner.logo}
                      alt={partner.name}
                      width={140}
                      height={50}
                      className="h-12 w-auto object-contain brightness-0 invert opacity-70 hover:opacity-100 transition-opacity duration-200"
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </div>

        {/* Bottom divider */}
        <div className="relative">
          <div className="h-px bg-white/30" />
        </div>
      </div>
    </section>
  );
}
